<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-md-8 text-center">
        <div class="error-template">
          <h1 class="display-1 text-muted">404</h1>
          <h2 class="mb-4">Page Not Found</h2>
          <div class="error-details mb-4">
            <p class="lead">Sorry, the page you are looking for does not exist.</p>
            <p class="text-muted">The requested URL <code>{{ $route.path }}</code> was not found on this server.</p>
          </div>
          <div class="error-actions">
            <router-link to="/" class="btn btn-primary btn-lg me-3">
              <i class="bi bi-house"></i> Go Home
            </router-link>
            <button @click="goBack" class="btn btn-outline-secondary btn-lg">
              <i class="bi bi-arrow-left"></i> Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.error-template {
  padding: 40px 15px;
  text-align: center;
}

.error-template h1 {
  font-size: 6rem;
  font-weight: 300;
  color: #6c757d;
}

.error-template h2 {
  color: #495057;
}

.error-details {
  margin: 30px 0;
}

.error-actions {
  margin-top: 30px;
}

code {
  background-color: #f8f9fa;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.9em;
  color: #e83e8c;
}
</style>
